import { AutomationRule } from '../../model/automation-rule.model';

export class LoadRules {
  static readonly type = '[Automation] Load Rules';
  constructor(
    readonly page: number,
    readonly maxResults: number,
  ) {}
}

export class CreateRule {
  static readonly type = '[Automation] Create Rule';
  constructor(readonly payload: Omit<AutomationRule, 'id'>) {}
}

export class UpdateRule {
  static readonly type = '[Automation] Update Rule';
  constructor(
    readonly id: number,
    readonly payload: Omit<AutomationRule, 'id'>,
  ) {}
}

export class DeleteRule {
  static readonly type = '[Automation] Delete Rule';
  constructor(readonly id: number) {}
}
